export const NAME = "vue-query-nuxt";
export const configKey = "vueQuery";
const composables = [
  "useQuery",
  "useQueries",
  "useInfiniteQuery",
  "useMutation",
  "useIsFetching",
  "useIsMutating",
  "useQueryClient"
];
export const defaults = {
  stateKey: NAME,
  autoImports: [...composables],
  queryClientOptions: {
    defaultOptions: { queries: { staleTime: 5e3 } }
  },
  vueQueryPluginOptions: {}
};
export function getVueQueryOptions(config) {
  return config.public[configKey];
}
